import React, { ComponentProps } from "react";
import { useTranslation } from "react-i18next";
import { Box, Typography } from "@mui/material";
import { DepotsSelector } from "@features/selectDepots/DepotsSelector";
import { AssetClassFilterChip } from "@features/depots/components/DepotsDashboard/assetClassFilter";

type Props = Pick<
  ComponentProps<typeof DepotsSelector>,
  "selectedGroup" | "accountParams" | "selectedGroupParams" | "onSave"
>;

export const InvestmentsPageTitle = (selectorProps: Props) => {
  const { t } = useTranslation();

  return (
    <Box>
      <Typography variant="h4" mb={{ xs: 1, sm: 2.5 }}>
        {t("breadcrumbs.investments")}
      </Typography>
      <Box
        display="flex"
        alignItems="center"
        flexWrap="wrap"
        columnGap={3}
        rowGap={1}
      >
        <DepotsSelector
          {...selectorProps}
          color="text.secondary"
          sx={{
            fontSize: "16px",
            lineHeight: "24px",
            fontWeight: 600,
          }}
        />
        <AssetClassFilterChip />
      </Box>
    </Box>
  );
};
